import './Header.css'
const Header = () => {
  return (
    <div className="header">
        <h1>Book List</h1>
    </div>
  )
}

export default Header